import { useCallback, useRef } from 'react';

import {
  INewbuildingMicrofrontendWidgetLocalAPI,
  IOpenBrokerModalParams,
} from '../../types/microfrontends/newbuildingBrokerWidget';

import type { ICianMFUIElement } from '@cian/mf-registry/browser';

export const useNewbuildingBrokerWidgetAPI = () => {
  const widgetRef = useRef<ICianMFUIElement>(null);

  const getLocalAPI = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (): INewbuildingMicrofrontendWidgetLocalAPI => (widgetRef.current?.instance?.customElement as any)?.api,
    [widgetRef],
  );

  const openWidget = useCallback(
    async (params: IOpenBrokerModalParams): Promise<void> => getLocalAPI()['/v2/open'](params),
    [getLocalAPI],
  );

  return {
    widgetRef,
    openWidget,
  };
};
